// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"654":"dbd9e87669e6e523","670":"ce10c213dd905ddd","772":"396291aca92a0f13","844":"c764c796da41d6a5","880":"00fdc9fc373ec097"}[chunkId] + ".js";
};